import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Layout } from './Layout.js';
import { LoginPage } from './pages/LoginPage.js';
import { VerifyPage } from './pages/VerifyPage.js';
import {
  NotFoundPage,
  OrderCancelPage
} from './pages/Placeholder.js';
import { CartPage } from './pages/CartPage.js';
import { CatalogPage } from './pages/CatalogPage.js';
import { DownloadsPage } from './pages/DownloadsPage.js';
import { LicensesPage } from './pages/LicensesPage.js';
import { OrderSuccessPage } from './pages/OrderSuccessPage.js';
import { OrdersPage } from './pages/OrdersPage.js';
import { ProductDetailPage } from './pages/ProductDetailPage.js';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1 }
  }
});

export function App(): JSX.Element {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<CatalogPage />} />
            <Route path="product/:productId" element={<ProductDetailPage />} />
            <Route path="cart" element={<CartPage />} />
            <Route path="orders" element={<OrdersPage />} />
            <Route path="orders/:orderId/success" element={<OrderSuccessPage />} />
            <Route path="orders/:orderId/cancel" element={<OrderCancelPage />} />
            <Route path="licenses" element={<LicensesPage />} />
            <Route path="downloads" element={<DownloadsPage />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="verify" element={<VerifyPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
